import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import { observer } from "mobx-react";
import styled from "styled-components";
import Modal from "module-common/Modal";
import {
  queryGetOngkirCity,
  mutationCekOngkir,
  queryGetOngkirCompany
} from "Apollo";
import PropTypes from "prop-types";
import { Scrollbars } from "react-custom-scrollbars";

import Icon from "module-common/Icon";
// import TextArea from "../../../module-common/TextArea";
import { Row } from "antd";
import Input from "module-common/Input";
import Button from "module-common/Button";
import { AutoComplete, Card } from "antd";
import { CaseManagementStore } from "Store";
import { CommonStore } from "Store";
import { Checkbox } from "antd";
// const { Checkbox } = antd;
const CheckboxGroup = Checkbox.Group;
const Option = AutoComplete.Option;
const OptGroup = AutoComplete.OptGroup;
const plainOptions = ["JNE", "TIKI", "POS"];
export default compose(
  graphql(queryGetOngkirCity, { name: "city" }),
  graphql(queryGetOngkirCompany, { name: "setting" }),
  graphql(mutationCekOngkir, {
    name: "cekOngkir"
  })
)(
  observer(
    class CekOngkirModal extends Component {
      state = {
        dataSource: [],
        origin: 0,
        destination: 0,
        weight: 0,
        ongkir: [],
        filteredOngkir: [],
        template: "",
        filter: true
      };
      static PropTypes = {
        text: PropTypes.string,
        onCancel: PropTypes.func
      };

      onSelectOrigin = value => {
        this.setState({
          origin: value
        });
      };
      onSelectDestination = value => {
        this.setState({
          destination: value
        });
      };

      componentWillReceiveProps(props) {
        const { city, setting } = props;
        this.setState({
          template: setting.getOngkirCompany.template
        });
        if (!city.loading) this.AddToDataSource(city.getOngkirCity);
      }

      AddToDataSource(City) {
        this.setState({
          dataSource: City.map(city => (
            <Option key={`${city.type} ${city.city_name}`} value={city.city_id}>
              {`${city.type} ${city.city_name}`}
            </Option>
          ))
        });
      }

      checkOngkir = async () => {
        const { origin, destination, weight } = this.state;
        await this.props
          .cekOngkir({
            variables: {
              originId: parseInt(origin),
              destinationId: parseInt(destination),
              weight: parseInt(weight)
            }
          })
          .then(response => {
            this.setState({
              ongkir: response.data.cekOngkir,
              filteredOngkir: response.data.cekOngkir
            });
          });
      };

      storeToCase = (str, mapObj) => {
        var re = new RegExp(Object.keys(mapObj).join("|"), "gi");
        return str.replace(re, function (matched) {
          return mapObj[matched.toLowerCase()];
        });
      };

      handleClick = ongkir => {
        console.log("Item :", ongkir);
        const { template } = this.state;
        const { onCancel } = this.props;
        var replace = {
          _origin: ongkir.origin,
          _destination: ongkir.destination,
          _courier: ongkir.name,
          _service: ongkir.service,
          _weight: ongkir.weight,
          _cost: ongkir.cost
        };
        const readyToStore = this.storeToCase(template, replace);
        CaseManagementStore.message =
          CaseManagementStore.message + " " + readyToStore;
        onCancel(true);
      };
      onChangeCheckBox = event => {
        var temp = this.state.ongkir
        let filter = temp.filter((o) => {
          if (event.length < 3) {
            console.log(event.indexOf(o.courier.toUpperCase()))
            return event.indexOf(o.courier.toUpperCase()) < 0 ? false : true
          }
          else
            return true
        })
        this.setState({
          filteredOngkir: filter
        })
      };
      render() {
        const { text, onCancel } = this.props;
        const { dataSource, origin, destination, filteredOngkir } = this.state;

        return (
          <Modal>
            <Wrapper>
              <Scrollbars>
                <HeaderWrapper>
                  <Text style={{ margin: "10px 0 0 15px" }}>Cek Ongkir</Text>
                  <XIcon
                    name="x-button-blue"
                    mode="contain"
                    width={30}
                    height={30}
                    onClick={onCancel}
                  />
                </HeaderWrapper>
                <TemplateWrapper>
                  <FlexParent>
                    <InputWrapper>
                      <ChildWrapper>
                        <TemplateText>Kota Asal Pengiriman</TemplateText>
                        <AutoComplete
                          size="large"
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          style={{ width: "170px" }}
                          dataSource={dataSource}
                          onSelect={this.onSelectOrigin}
                          placeholder="Pilih Kota Asal"
                        />
                      </ChildWrapper>
                      <ChildWrapper>
                        <TemplateText>Kota Tujuan Pengiriman</TemplateText>
                        <AutoComplete
                          size="large"
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          style={{ width: "170px" }}
                          dataSource={dataSource}
                          onSelect={this.onSelectDestination}
                          placeholder="Pilih Kota Tujuan"
                        />
                      </ChildWrapper>
                      <ChildWrapper>
                        <TemplateText>Berat Kiriman (Gram)</TemplateText>
                        <Input
                          placeholder="Input Berat (Gram)"
                          onChange={e =>
                            this.setState({ weight: e.target.value })
                          }
                          style={{ width: "130px", height: "32px" }}
                        />
                      </ChildWrapper>
                    </InputWrapper>
                    <ButtonWrapper>
                      <Button
                        color="blue"
                        size="large"
                        style={{
                          width: "150px",
                          height: "32px",
                          borderRadius: "15px"
                        }}
                        onClick={this.checkOngkir}
                      >
                        Cek Ongkir{" "}
                      </Button>
                    </ButtonWrapper>
                  </FlexParent>
                  <FilterWrapper>
                    <FilterChild>
                      <Icon
                        name="filter"
                        height={20}
                        width={15}
                        style={{ "margin-right": "6px" }}
                      />
                      <FilterText>Filter Kurir</FilterText>
                    </FilterChild>
                    <FilterChild style={{ "margin-left": "30px" }}>
                      <CheckboxGroup
                        options={plainOptions}
                        defaultValue={['JNE', 'TIKI', 'POS']}
                        onChange={this.onChangeCheckBox}
                      />
                      {/* <Checkbox
                        checked={this.state.isCsatSent}
                        onChange={this.onChangeCheckBox}
                      >
                        <FilterText>JNE</FilterText>
                      </Checkbox>
                      <Checkbox
                        checked={this.state.isCsatSent}
                        onChange={this.onChangeCheckBox}
                      >
                        <FilterText>Tiki</FilterText>
                      </Checkbox>
                      <Checkbox
                        checked={this.state.isCsatSent}
                        onChange={this.onChangeCheckBox}
                      >
                        <FilterText>Pos</FilterText>
                      </Checkbox> */}
                    </FilterChild>
                  </FilterWrapper>
                  <CardTitle>
                    <Text>Kurir</Text>
                    <Text>Jenis Layanan</Text>
                    <Text>Tarif</Text>
                  </CardTitle>
                  <div>
                    {filteredOngkir.map(item => (
                      <CardList
                        hoverable
                        onClick={e => this.handleClick(item)}
                        style={{
                          "border-radius": "10px",
                          "margin-bottom": "15px"
                        }}
                      >
                        <CardWrapper>
                          <LogoJasa>
                            <img src={item.logo} width="55" height="30" />
                            <CardChild style={{ width: "200px" }}>
                              <TemplateText style={{ marginBottom: "-5px" }}>
                                {item.courier.toUpperCase()}
                              </TemplateText>
                              <FilterText>{item.name}</FilterText>
                            </CardChild>
                          </LogoJasa>
                          <CardChild style={{ width: "380px" }}>
                            <TemplateText style={{ marginBottom: "-5px" }}>
                              {item.service.toUpperCase()}
                            </TemplateText>
                            <FilterText>{item.description}</FilterText>
                          </CardChild>
                          <CardChild style={{ width: "135px" }}>
                            <TemplateText>Rp. {item.cost}</TemplateText>
                          </CardChild>
                        </CardWrapper>
                      </CardList>
                    ))}
                  </div>
                </TemplateWrapper>
              </Scrollbars>
            </Wrapper>
          </Modal>
        );
      }
    }
  )
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 60vw;
  height: 90vh;
  margin: -20px;
`;
const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
// color: ${props => props.theme.uiText};
const Text = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: #404040;
`;
const TemplateWrapper = styled.div`
  display: flex;
  margin: 0 25px 0 25px;
  flex-direction: column;
`;
const ChildWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
`;
const TemplateText = styled.span`
  font-size: 0.9rem;
  font-weight: 550;
  color: #404040;
  margin-bottom: 10px;
`;
// const TemplateChild = styled.div`
//   display: flex;
//   flex-direction: column;
//   padding: 10px 0 10px 0;
// `;
const ButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  margin-left: 10px;
  padding-bottom: 2px;
`;
const TextArea = styled.textarea`
  width: 400px;
  min-height: 30px;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 4px;
  padding: 10px 15px 0 15px;
  box-sizing: border-box;
  resize: none;
  font-size: 1rem;
  font-weight: 490;
  text-align: justify;
  background: ${props => (props.disabled ? "#ddd" : "#fff")};
`;
const XIcon = styled(Icon) `
  margin: 10px 15px 10px 0;
`;

const FlexParent = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px 0 20px 0;
  justify-content: space-between;
`;
const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  align-items: center;
`;
const FilterChild = styled.div`
  display: flex;
  flex-direction: row;
`;
const FilterText = styled.span`
  font-size: 1rem;
  font-weight: 490;
`;
const CardTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;
const CardList = styled(Card) `
  margin-top: 10px;
  border-radius: 10px;
  &:hover {
    cursor: pointer;
  }
`;
const CardChild = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10px 0 10px 10px;
`;
// align-items: center;
const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const LogoJasa = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/CekOngkirModal.js